import { TasksState } from './TasksProvider';

function withTasksSidebarActions(WrappedComponent) {
  return (props) => {
    return (
      <TasksState.Consumer>
        {(tasksState) => {
          // sidebarType = oneOf(["edit"]) - can only be edit; assign was removed
          const openSidebar = (task = null, sidebarType = 'edit', defaultValues = {}) => {
            tasksState.dispatch({
              type: 'OPEN_SIDEBAR',
              payload: task,
              sidebarType,
              defaultValues,
            });
          };

          const closeSidebar = () => {
            tasksState.dispatch({ type: 'CLOSE_SIDEBAR' });
          };

          const state = {
            sidebarOpen: tasksState.sidebarOpen,
            openSidebar,
            closeSidebar,
          };
          return <WrappedComponent {...state} {...props} />;
        }}
      </TasksState.Consumer>
    );
  };
}

export default withTasksSidebarActions;
